import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersKnowledgeInsightPostSearchItemsIndexResponseType } from "~/domains";

type ParamsType = {
  employeeRoleId: number;
};

const request = async ({
  employeeRoleId,
}: ParamsType): Promise<ApiMembersKnowledgeInsightPostSearchItemsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersKnowledgeInsightPostSearchItemsIndexResponseType>(
      "/api/members/knowledge_insight_post_search_items",
      { employeeRoleId },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  employeeRoleId: number;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersKnowledgeInsightPostSearchItemsIndex = ({
  employeeRoleId,
  config = {},
}: PropsType): UseQueryResult<ApiMembersKnowledgeInsightPostSearchItemsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisMembersKnowledgeInsightPostSearchItemsIndex",
      employeeRoleId,
    ],
    queryFn: () => request({ employeeRoleId }),
  });
};
